import settings from '@config/settings'
import { LANGUAGES } from '@constants'
import { translation } from '@integrations/translation'

void translation.initialize({
  language: LANGUAGES.EN,
  fallbackLanguage: LANGUAGES.EN,
  supportedLanguages: ['en-US', ...settings.languages],
  resourcePath: '/i18n/{{lng}}.json',
  namespace: 'translation',
  suspense: true,
  debug: false
})
